import { ButtonLink } from '@npco/zeller-design-system'
import styled from 'styled-components'

export const ContactSupportButtonLink = styled(ButtonLink)`
  display: inline;
  font-size: 18px;
`
